import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
// import {Link} from 'react-router-dom'
import { useFormik } from 'formik'
import agentComponent from '../../../biz/agentBiz'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const initialValues = {
  username: '',
}

const forgotPasswordSchema = Yup.object().shape({
  username: Yup.string()
    // .email('Wrong email format')
    // .min(3, 'Minimum 3 symbols')
    // .max(50, 'Maximum 50 symbols')
    .required('User name is required'),
})

export function ForgotPassword(props: any) {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setSubmitting(false)
      try {
        // console.log(values)
        values.username = values.username.trim();
        const result = await agentComponent.forgotPassword(values.username)
        if (result) {
          setStatus(result.message)
          setHasErrors(false)
        }
      } catch (err: any) {
        if (err.response && err.response.status === 404) {
          setStatus(err.response.data.message)
          setHasErrors(true)
        }
      } finally {
        setLoading(false)
        setSubmitting(false)
      }
    },
  })

  const handleAuthState = () => {
    props.authState('LOGIN')
  }

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-11 auth-nextsix-agent-logo'>
        <img src={`${toAbsoluteUrl('/media/auth/nextsix-agent-logo.png')}`} alt='' />
      </div>

      {/* begin::Title */}
      {hasErrors === true && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {hasErrors === false && (
        // <div className='mb-10 bg-light-info p-8 rounded'>
        <div className='mb-lg-12 alert alert-success'>
          <div className='text-success'>{formik.status}</div>
        </div>
      )}
      {/* end::Title */}

      {/* begin::Form group */}
      <p className='form-label mb-3 auth-forgot-reminder'>
        Enter your user name or email address and we will send you a password reset link.
      </p>
      <div className='fv-row mb-3'>
        <div className='auth-input-box'>
          <label className='form-label auth-input-text'>User Name / Email Address</label>
          <input
            type='username'
            placeholder='user name / email address'
            autoComplete='off'
            {...formik.getFieldProps('username')}
            className={clsx(
              'form-control bg-transparent auth-input-field',
              // { 'is-invalid': formik.touched.username && formik.errors.username },
              // {
              //   'is-valid': formik.touched.username && !formik.errors.username,
              // }
            )}
          />
        </div>
        {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.username}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <span></span>
        <button onClick={handleAuthState} className='auth-forgot-button' type='button'>
          back to sign in
        </button>
      </div>

      {/* begin::Form group */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_password_reset_submit'
          className='btn auth-sign-in-button'
        // disabled={formik.isSubmitting || !formik.isValid}
        >
          <span className='indicator-label'>Submit</span>
          {loading && (
            <span className='indicator-progress'>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Form group */}
    </form>
  )
}
